import React, { useState } from "react";
import AssetDeallocation from "./AssetDeallocation";
import AccessDeallocation from "./AccessDeallocation";
import PageTitle from "../../components/PageTitle";
import { toggleMenu } from "../../utils/helpers";

const ITAssetAndAccessDeallocationTabs = ({ title, description }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const tabs = [
    { label: "Return Asset", component: AssetDeallocation },
    { label: "Revoke Access", component: AccessDeallocation },
  ];

  return (
    <div className="wrapper-body">
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} description={description} />
      </div>

      <div className="card">
        <div className="d-flex justify-content-between align-items-center">
          <ul className="nav nav-tabs" role="tablist">
            {tabs.map((item, index) => (
              <li className="nav-item" role="presentation" key={index}>
                <button
                  className={`nav-link ${
                    activeTabIndex === index ? "active" : ""
                  }`}
                  type="button"
                  role="tab"
                  aria-selected={activeTabIndex === index}
                  onClick={() => setActiveTabIndex(index)}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="tab-content mt-3 px-3">
          {tabs.map((item, index) => {
            const Component = item.component;
            return (
              activeTabIndex === index && (
                <div
                  key={index}
                  className="tab-pane fade show active"
                  role="tabpanel"
                >
                  <Component title={item.label} description="" />
                </div>
              )
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ITAssetAndAccessDeallocationTabs;
